class EmailUtils {

  static alreadySubscribedResponse () {
    return 'snippetTemplate.alreadySubscribed.alreadySubscribedDescription'
  }

  static validateEmail (vState) {
    const missingEmail = 'header.loginForm.email.errors.missingEmail'
    const invalidEmail = 'header.loginForm.email.errors.invalidEmail'

    vState.$touch()
    const errors = []

    if (!vState.required) {
      errors.push(missingEmail)
    } else if (!vState.email) {
      errors.push(invalidEmail)
    }

    return errors
  }
}

export default EmailUtils
